export const LINKED_IN = "https://www.linkedin.com/company/all3";
export const YOUTUBE = "https://youtube.com/@all3com";
export const TIKTOK = "https://www.tiktok.com/@all3com";
export const INSTAGRAM = "https://www.instagram.com/all3com/";

export const MAIL_TO_EMAIL = "info@all3.com";
